/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-markup-string',
    templateUrl: './markup-string.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class MarkupStringComponent {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.markup-string.downgraded',
        directiveName: 'sisMarkupString',
    };

    @Input() label?: string;
    @Input() value: string;
}
